import React from "react";
import { Navigate } from "react-router-dom";
import { useFeatureFlags } from "../../context/FeatureFlagContext";
import type { FeatureFlags } from "../../types/api";
import { DASHBOARD_ROUTE } from "../../constants/RoutePaths";

interface RequireFeatureFlagProps {
  flag: keyof FeatureFlags;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

/**
 * Route guard that renders `children` only when the named feature flag is truthy.
 * On a falsy flag, renders `fallback` (default: redirect to /dashboard).
 *
 * Companion to <RequirePermission /> for permission gating.
 */
export const RequireFeatureFlag: React.FC<RequireFeatureFlagProps> = ({
  flag,
  children,
  fallback,
}) => {
  const flags = useFeatureFlags() as unknown as FeatureFlags;
  const enabled = Boolean((flags as Record<string, unknown>)[flag as string]);

  if (!enabled) {
    return <>{fallback ?? <Navigate to={DASHBOARD_ROUTE} replace />}</>;
  }
  return <>{children}</>;
};

export default RequireFeatureFlag;
